import { AddOutlined, EditOutlined, RefreshOutlined } from "@material-ui/icons";
import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../../../../hooks/useToast";
import useConfirm from "../../../../hooks/useConfirm";
import SearchIcon from "@mui/icons-material/Search";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { AMIService } from "../../../../service/AMI/AMIService";
import AdministrateursDialogForm from "./AdministrateursDialogForm";
import { PgiUserService } from "../../../../service/admin_service/PgiUserService";
import { render } from "@testing-library/react";

const UtilisateursPGIList = ({
  selection = false,
  id_type,
  handleSelectedCV,
}) => {
  const [pgiUsers, setPgiUsers] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const navigate = useNavigate();
  const { Toast, showToast } = useToast();
  const [pgiUserFormOpen, setPgiUserFormOpen] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [idUserPgi, setIdUserPgi] = useState(null);
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleFetchVolontariatOffreList = () => {
    setDataLoading(true);
    PgiUserService.lister({})
      .then((res) => {
        if (res && res.data) {
          setPgiUsers(res.data);
          setFilteredRows(res.data);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleCloseAmiForm = () => {
    setPgiUserFormOpen(false);
    handleFetchVolontariatOffreList();
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(pgiUsers);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      pgiUsers.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot)
          )
        )
      )
    );
  };

  const table_colonne = [
    {
      field: "libelle_type",
      headerName: "Nom et prenoms",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return params.row.last_name + " " + params.row.first_name;
      },
    },
    {
      field: "email",
      headerName: "Adresse email",
      flex: 0.5,
      minWidth: 150,
    },
    /* {
      field: "cloture",
      headerName: "Contact",
      flex: 0.5,
      minWidth: 80,
      renderCell: (params) => {
        return params.row.cloture === "1" ? "Oui" : "Non";
      },
    }, */
    {
      field: "direction_name",
      headerName: "Direction",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "service_name",
      headerName: "Service",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Parametrer AMI"
              color="primary"
              // onClick={(e) => handleShowCandidatList(params.row.id_type)}
            >
              <SettingsOutlinedIcon />
            </IconButton>
            <IconButton
              color="primary"
              // onClick={(e) => handleOpenOpenAmiForm(null)}
              title="Ajouter nouveau administrateur"
            >
              <AddOutlined />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchVolontariatOffreList();
  }, []);

  return (
    <>
      <AdministrateursDialogForm
        open={pgiUserFormOpen}
        onFormClose={() => handleCloseAmiForm()}
        idAmi={idUserPgi}
      />
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Les utilisateurs PGI"
              action={
                <Grid container spacing={2} justifyContent="space-around">
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      placeholder="Recherche"
                      onChange={(e) => handleFilter(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      title="Actualiser"
                      color="primary"
                      onClick={handleFetchVolontariatOffreList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                // rows={offres}
                rows={filteredRows}
                getRowId={(row) => row.user_id}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default UtilisateursPGIList;
